import { useStore } from '@/stores/index'
export default defineNuxtRouteMiddleware((to, from) => {
  // const runtimeConfig = useRuntimeConfig()

  // マルイにコンテンツ一覧があったためTOPページに遷移するようにリダイレクト処理
  const reg = /^(\/content|\/content\/)$/
  if (reg.test(to.path)) {
    redirect('/')
  }
   
  const cookieEnabled = navigator.cookieEnabled
  if (to.name !== 'iframe' && !cookieEnabled) {
    throw showError({ message: 'cookie-error', statusCode: 500, fatal: true })
  }

  // ROUTING
  const rootStore = useStore()
  // const gtm = useGtm()
  // const gtag = useGtag()

  rootStore.$patch({ alertMessage: { title: '', body: ''}})
  rootStore.$patch({ messageDialogs: [{ name: 'ALERT', shown: false }]})

  // rootStore.$patch({ isContentLoaded: false })
  // if (gtm) {
  //   gtm.trackEvent({ uid: 'test' })
  //   gtm.trackEvent({
  //     routeName: to.name,
  //     pageType: 'PageView',
  //     pageUrl: `/${runtimeConfig.public.chainKey}/${runtimeConfig.public.paddingedChainId}${to.fullPath}`, 
  //     pageTitle: (typeof document !== 'undefined' && document.title) || '',
  //     event: 'nuxtRoute'
  //   })
  // }
  // if (gtag) {
  //   // gtm.trackEvent({ uid: 'test' })
  //   gtag('event', 'nuxtRoute', {
  //       routeName: to.name,
  //       pageType: 'PageView',
  //       pageUrl: `/${runtimeConfig.public.chainKey}/${runtimeConfig.public.paddingedChainId}${to.fullPath}`, 
  //       pageTitle: (typeof document !== 'undefined' && document.title) || '',
  //   })
  // }
})